import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bundle, ebookImage } from '../data/content';
export function Bundle() {
  const [featured, ...rest] = bundle;
  return <section id="contenido" className="bg-cream" data-id="element-26" data-mp="13o4msz9d07w8">
      <div className="mx-auto max-w-6xl px-6 py-16 lg:py-24" data-id="element-27" data-mp="13ow73dxiaj77">
        <div className="max-w-2xl" data-id="element-28" data-mp="zmsuglz3p8kc">
          <p className="text-sm font-semibold text-teal" data-id="element-29" data-mp="znugflhnnfgu">Lo que recibes</p>
          <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-30" data-mp="1wd1te547kg95">
            Todo el bundle, disponible al instante
          </h2>
        </div>

        <div className="mt-12 grid gap-10 lg:grid-cols-[1.15fr_0.85fr]" data-id="element-31" data-mp="1mmqpujofs92s">
          <div className="flex flex-col justify-between gap-8 rounded-[2rem] bg-teal-soft/60 p-8 ring-1 ring-teal/15 sm:flex-row sm:items-center sm:p-10" data-id="element-32" data-mp="1mkmbf7swvro9">
            <div data-id="element-33" data-mp="2f4bcn63s6jdx">
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-teal-deep" data-id="element-34" data-mp="2f4upi8ekqhl3">
                Recurso principal
              </p>
              <h3 className="mt-3 font-display text-2xl font-semibold leading-snug text-ink sm:text-3xl" data-id="element-35" data-mp="1khodvnvvyrt9">
                {featured.name}
              </h3>
              <p className="mt-4 max-w-prose leading-relaxed text-ink/70" data-id="element-36" data-mp="1pfps9vida2ye">
                {featured.text}
              </p>
            </div>
            <img src={ebookImage} alt="Portada de la Guía Maestra Método Vientre Plano 21D" className="w-32 shrink-0 rounded-xl object-cover shadow-md shadow-ink/10 sm:w-40" loading="lazy" data-id="element-37" data-mp="1fqep0pi5vsif" />
          </div>

          <ul className="divide-y divide-ink/10 border-y border-ink/10" data-id="element-38" data-mp="16nna2fq2uem1">
            {rest.map(item => <li key={item.name} className="flex gap-4 py-5" data-id="element-39" data-mp="wru1f7fhb59j">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-40" data-mp="wsc1kf59i3mq" />
                <div data-id="element-41" data-mp="2r5l57qb4mux2">
                  <h3 className="font-semibold text-ink" data-id="element-42" data-mp="2r4s7tfy25hrl">{item.name}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-ink/65" data-id="element-43" data-mp="2poeg6ohqyco4">
                    {item.text}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}